import { parse as parseCookie } from "cookie";

import { rollbarAndLogError } from "./logger";

import { serverLogout } from "api/api-server-actions";
import { AppDispatch } from "store/index";
import { clearPubsubAPICache } from "store/pubsub-slice";
import { aiStateActions } from "store/slices/ai";
import { resetReduxContent } from "store/utils";

export const getCsrfToken = () => parseCookie(document.cookie).csrftoken;
export const getOrgIdFromCookie = () => parseCookie(document.cookie).org_id;

/** SameSite=None (w/ Secure) for LMS iframes; plain attrs on http so jsdom/local still work. */
const orgCookieAttrs = () =>
  window.location.protocol === "https:" ? "; Secure; SameSite=None" : "";

export const setOrgIdCookie = (orgId: string) => {
  const domain = window.location.hostname;
  document.cookie = `org_id=${orgId}; path=/; domain=.${domain}${orgCookieAttrs()}`;
};
export const clearOrgIdCookie = () => {
  const domain = window.location.hostname;
  document.cookie = `org_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain}${orgCookieAttrs()}`;
};

export const setLastSectionIdCookie = (sectionId: string) => {
  const domain = window.location.hostname;
  document.cookie = `section_id=${sectionId}; path=/; domain=.${domain}`;
};
export const getLastSectionIdFromCookie = () => parseCookie(document.cookie).section_id;

export const logoutAndClearCaches = (dispatch: AppDispatch) => {
  serverLogout()
    .catch((error) => {
      rollbarAndLogError("Could not log out", error);
    })
    .finally(() => {
      // Even if we fail to log out, we clear all the local state and caches, so that
      // it appears the user is logged out, and the user has a chance to log back in,
      // possibly fixing the issue that caused the logout to fail.
      dispatch(aiStateActions.clearAiChatMessages());
      clearPubsubAPICache();
      dispatch(resetReduxContent());
    });
};
